/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_File_Statistics_Pattern_ExcludedInputs */



/**
* | output |
* | --- |
* | "Filtered" |
*
* @param {Spaces_File_Statistics_Pattern_ExcludedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_file_statistics_pattern_excluded = /** @type {((inputs?: Spaces_File_Statistics_Pattern_ExcludedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_File_Statistics_Pattern_ExcludedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gefiltert")
	return /** @type {LocalizedString} */ ("Filtered")
});